<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_mypage">
            <article class="srch_detail">
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select id="strRhqcd" name="strRhqcd" v-model="strRhqcd" @change="changeRhqCd($event)" class="slt_white w100p">
                                    <option value="" v-if="isAllUser()" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option value="" v-else disabled>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                    <option v-for="(item, index) in rhqCdList" :key="item.code" :value="item.code">{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select id="loginCorp" name="loginCorp" v-model="loginCorp" @change="changeCorpCd($event)" class="slt_white w100p">
                                    <option value="" v-if="isAllUser()" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option value="" v-else disabled>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                    <option v-for="(item, index) in rhqSubCdList" :key="item.code" :value="item.code" >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.MENU') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100p"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100p"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD1"
                                        v-model="PRD_CATEGORY_CD1"
                                        @change="changeCategory1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList1.length > 0"
                                            v-for="item in categoryComboList1"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD2"
                                        v-model="PRD_CATEGORY_CD2"
                                        @change="changeCategory2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList2.length > 0"
                                            v-for="item in categoryComboList2"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD3"
                                        v-model="PRD_CATEGORY_CD3"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList3.length > 0"
                                            v-for="item in categoryComboList3"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_input">
                    <dt>{{ $t('FIELD.GLOBAL.DELETED.DATE') }}</dt>
                    <dd data-input-type="date">
                        <fieldset class="ui_fieldset">
                            <label class="date-wrap">
                                <input id="fromDate" type="text" class="date_input w100p" :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                            </label>
                            <div id="from-picker-container" style="margin-top: -1px;"/>
                            <em class="txt_space"></em>
                            <label class="date-wrap">
                                <input id="toDate" type="text" class="date_input w100p" :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                            </label>
                            <div id="to-picker-container" style="margin-top: -1px;"/>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_search">
                    <dt>{{ $t('FIELD.MYKNOWLEDGE.KEYWORD') }}</dt>
                    <dd data-input-type="select">
                        <select class="slt_white w100p"
                                id="searchStatus"
                                v-model="searchStatus"
                                @change="() => { searchKeyword = '' }"
                        >
                            <option value="subject">{{ $t('FIELD.GLOBAL.SUBJECT') }}</option>
                            <option value="model">{{ $t('FIELD.GLOBAL.MODEL') }}</option>
                        </select>
                    </dd>
                    <dd class="clearable" data-input-type="input">
                        <input  id="searchKeyword"
                                name="searchKeyword"
                                type="text"
                                class="text_input w100p"
                                v-model.trim="searchKeyword"
                                :maxlength="searchStatus === 'subject' ? 200 : 30" 
                                :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                                @keyup.enter.stop="handleSearch"
                                v-clearable
                        >
                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                    </dd>
                </dl>
                <!-- 200714수정 S -->
                <span class="srch_mypage_btn">
                    <a href="javascript:" class="btn_srch" @click="handleSearch">{{ $t('FIELD.GLOBAL.SEARCH') }}</a>
                </span>

            </article>
        </div>

        <!-- Grid -->
        <div class="grid_wrap" v-if="!isLoading" v-resize="setGridResizeColumn">
            <!-- Count -->
            <div class="grid_total">Total Count <em>{{ totalCount | numberFormat }}</em></div>
            <div v-if="params.creationYn === 'Y'" class="btn_wrap">
                <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.RECOVER')" @click="btnRecover">{{ $t('BUTTON.GLOBAL.RECOVER') }}</a>
                <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.TRASH')" @click="btnRemove">{{ $t('BUTTON.GLOBAL.REMOVE') }}</a>
            </div>
            <trash-grid
                :gridId="gridId"
                :ref="gridId"
                :columns="columns"
                :data="gridData"
                :options="options"
                :pageOptions="pageOptions"
                :isTotalCount="false"
                :click="contentClick"
                @grid-total-count="setTotalCount"
            />
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import TrashListGrid                        from './TrashListGrid';

require('moment-jdateformatparser');

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

export default {
    name: 'TrashList',
    data() {
        return {
            isLoading: true,
            pageTitle: '',

            knowledgeList: [],

            strRhqcd: '',
            loginCorp: '',

            rhqCdList: [],
            rhqSubCdList: [],

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2

            PRD_CATEGORY_CD1: '',       // Category 1
            PRD_CATEGORY_CD2: '',       // Category 2
            PRD_CATEGORY_CD3: '',       // Category 3
            categoryComboList1: [],     // Category 1 List
            categoryComboList2: [],     // Category 2 List
            categoryComboList3: [],     // Category 3 List

            rangePicker: null,

            searchStatus: 'subject',
            searchKeyword: '',          // Subject
            searchTitle: '',
            selectedModel: '',

            gridId: 'expiringKnowledgeGrid',
            columns: [],
            options: {},
            pageOptions: {},
            gridData: [],

            totalCount: 0,
            pageNo: 1,
            currentPage: 1,
            perPage: localStorage.getItem('listRows') ? Number(localStorage.getItem('listRows')) : 10
        }
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getLoginRHQCd()         { return this.loginRhq || ''; },
        getSelLoginCorp()       { return this.loginCorp || ''; },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getSelCategory1()       { return this.PRD_CATEGORY_CD1 || ''; },
        getSelCategory2()       { return this.PRD_CATEGORY_CD2 || ''; },
        getSelCategory3()       { return this.PRD_CATEGORY_CD3 || ''; },
        getPageNo()             { return this.pageNo; },

    },
    directives: { resize },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'sdl-pagination'    : SDLPagination,
        'trash-grid'        : TrashListGrid,
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // 그리드 컬럼 세팅
            this.columns = this.getDynamicCols();
            // RHQ
            this.setRhqCd();
            // 게시판 타입 1 로드
            this.setBoardType1();
            // 초기 카테고리1 리스트 로드
            this.setCategory1();

            this.isLoading = false;
            // 조회 완료 후
            SDLUtil.showLoadingBar(false);

            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(this.isLoading); }, 1000 );
            });
        },
        setRhqCd() {
            let that = this;
            this.getCodeComboList(this.loginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data, this.strRhqcd = this.getLoginRHQCd;
                    this.rhqSubCdList = [], this.loginCorp = '';

                    setTimeout( () => {
                        this.getCodeComboList(this.strRhqcd, "SUB_AUTH_ACCESS_CD")
                            .then(data => {
                                that.rhqSubCdList = data;
                                that.loginCorp = that.getUserCorpCd;
                            });
                    }, 100 );
                });
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.rhqSubCdList   = [], this.loginCorp   = '';
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList   = data, this.loginCorp   = '';
                    this.boardType1List = [],   this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeCorpCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE1").then(data => {
                    this.boardType1List = data, this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            let additionalValue = (['RHQ_AUTH_ACCESS_CD', 'SUB_AUTH_ACCESS_CD'].includes(categoryCode)) ? this.getLoginNo : this.getUserCorpCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1").then(data => {
                this.BOARD_TYPE1 = this.getSelBoardType1;
                this.boardType1List = data;
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2 = '';
                });
            }
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.PRD_CATEGORY_CD1 = "";
                this.categoryComboList1 = data;
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // 권한체크
        isAllUser(){
            if(
                this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`)
             || this.getUserRole.includes(`${constants.GBM_ADMIN}`)
             || this.getUserRole.includes(`${constants.RHQ_ADMIN}`)
            ) {
                return true;
            } else {
                return false;
            };
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MENU'), name: 'BOARDTYPENM', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'), name: 'CATEGORYNM', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGETITLE', align: 'center', width: this.getColumnSize(30), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.EXPIRED.ON'), name: 'EXPIREDDATE', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.HIT'), name: 'HITCOUNT', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: 'KNOWLEDGE_ID', name: 'KNOWLEDGEID', hidden: true },
                { header: 'BOARDTYPE1NAME', name: 'BOARDTYPE1NAME', hidden: true },
                { header: 'PRDCATEGORY1NAME', name: 'PRDCATEGORY1NAME', hidden: true },
            ];
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 40) / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('trash-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            this.currentPage = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },

        // Search Parameter setting
        setSearchParameter() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');

            // 선택된 Status 에 따라 값을 다른 곳에 넣는다.
            if(this.searchStatus === 'subject') {
                this.searchTitle = (SDLUtil.nvl(this.searchKeyword)).toUpperCase();
                this.selectedModel = '';

            } else {
                this.searchTitle = '';
                this.selectedModel = (SDLUtil.nvl(this.searchKeyword)).toUpperCase();
            };

            let params = {
                loginCorp: this.getSelLoginCorp,
                boardType1: this.getSelBoardType1,
                boardType2: this.getSelBoardType2,
                prdCategoryCd1: this.getSelCategory1,
                prdCategoryCd2: this.getSelCategory2,
                prdCategoryCd3: this.getSelCategory3,
                knowledgeTitle: this.searchTitle,
                selectedModel: this.selectedModel,
                multi: 'N',
                searchDateStart: this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).formatWithJDF(mFormat) : '',
                searchDateEnd: this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(mFormat) : '',
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            };

            return params;
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!SDLUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo){
            if(pageNo !== null && pageNo != "") {
                this.pageNo = pageNo;
                this.knowledgeList = [];
                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 조회
        handleSearch() {
            // Call ExpiringKnowledgeListGrid.vue > loadData method
            EventBus.$emit('trash-search', this.setSearchParameter());
        },
        // 재조회
        reSearch(pageNo) {
            // this.setCategoryParam(boardParam.searchParams);
            this.pageNo = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 그리드 체크시 knowledgeId 를 선택함
        setCheckedList(rtnList = []) {
            Vue.$log.info('▶ ExpiringKnowledgeList.vue setCheckedList', rtnList);
            this.knowledgeList = rtnList;
        },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let knowledgeId = row['KNOWLEDGEID'] || '';
            Vue.$log.info('▶ ExpiringKnowledgeList.vue contentClick event. =>', row, knowledgeId);

            store.commit('POPUP_PARAMS', {
                knowledgeId : knowledgeId,
                isModify: false,
                isAdminMenu: true,
                adminButtonAuth: this.params.creationYn === 'Y' ? true : false,
                adminMenuType: 'TRS'
            });

            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            const detailPop = SDLUtil.openLegacyWindowPopup({
                url: linkUrl,
                title: SDLUtil.getMsgProp('TITLE.KNOWLEDGE.DETAIL'),
                w: 1366,
                h: 768
            });

            // 팝업이 닫히면 자동으로 리스트로 이동
            let self = this,
                popTimer = window.setInterval(function() {
                if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                    window.clearInterval(popTimer);
                    self.handleSearch();
                }
            }, 200);
        },
        btnRecover() {
            let that = this;
            if(this.knowledgeList.length === 0) {
                SDLUtil.alert('MESSAGE.DATA.CHECKRECOVER');

            } else {
                SDLUtil.confirm({
                    title: "TITLE.WARNING.TITLE",
                    msg: 'MESSAGE.DATA.RECOVER.CONFIRM',
                    onOkEvt: () => {
                        let params = { knowledgeList: this.knowledgeList };
                        return  axios.post(
                                    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/trash/trashRecover.skp`,
                                    qs.stringify(params),
                                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                                )
                                .then(res => {
                                    let data = res.data;
                                    if(data.msg) {
                                        SDLUtil.alert({
                                            title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                            msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                            onOkEvt: () => {
                                                // Expire Knowledge details
                                                that.handleSearch();
                                            }
                                        });
                                    }
                                })
                                .catch(err => {
                                    SDLUtil.errorAlert(err);
                                });
                    }
                });
            };
        },
        btnRemove() {
            let that = this;
            if(this.knowledgeList.length === 0) {
                SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');

            } else {
                SDLUtil.confirm({
                    title: "TITLE.WARNING.TITLE",
                    msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                    onOkEvt: () => {
                        let params = { knowledgeList: this.knowledgeList };
                        return  axios.post(
                                    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/trash/trashRemove.skp`,
                                    qs.stringify(params),
                                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                                )
                                .then(res => {
                                    let data = res.data;
                                    if(data.msg) {
                                        SDLUtil.alert({
                                            title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                            msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                            onOkEvt: () => {
                                                // Expire Knowledge details
                                                that.handleSearch();
                                            }
                                        });
                                    }
                                })
                                .catch(err => {
                                    SDLUtil.errorAlert(err);
                                });
                    }
                });
            };
        }
    },
    created(){
        Vue.$log.info('▶ ExpiringKnowledgeList.vue created.');
        EventBus.$on('trash-page-search',   pageNo      => { this.handlePageSearch(pageNo); });
        EventBus.$on('trash-sort-search',   sortForm    => { this.handleSortSearch(sortForm); });
        EventBus.$on('trash-list',          rtnList     => { this.setCheckedList(rtnList); });
    },
    mounted(){
        // DOM 생성 후 이벤트
        this.$nextTick(() => {
            // 범위 지정 Datepicker 로 변경
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false }
            );

            this.initLoad().then(loading => {
                if(!loading) {
                    this.searchTitle = this.$route.query.searchTitle;
                }
            });
        });

    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('trash-page-search');
        EventBus.$off('trash-sort-search');
        EventBus.$off('trash-list');
    }
};
</script>

<style>
.zindex9999 { z-index: 9999; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/trash/TrashList.vue